export const dropzoneHelper = {
  options(accessToken = '') {
    return {
      addRemoveLinks: true,
      acceptedFiles: ".png,.jpg, image/png, image/jpeg",
      headers: {
        "X-Csrf-Token": document.head.querySelector('meta[name="csrf-token"]').content,
        Authorization: "Bearer " + accessToken
      },
      maxFiles: 1,
      maxFilesize: 4, // in Mb
      thumbnailWidth: "247",
      thumbnailHeight: "143",
      url: window.laroute.route("api.temp-images.store"),
      withCredentials: true
    };
  }
}